export default __webpack_public_path__ + "static/media/Uni.0183a222.svg";